export default {
    'menu.support.pickUpRecord': 'Pick-up Record',
    'menu.support.NDelegation': 'Nomination Delegation',
    'support.pickUpRecord.name': 'Name',
    'support.pickUpRecord.search.employeeId': 'SAP Number',
    'support.pickUpRecord.search.department': 'Department',
    'support.pickUpRecord.search.startDate': 'Submit Start Date',
    'support.pickUpRecord.search.endDate': 'Submit End Date',
    'support.pickUpRecord.table.giftType': 'Gift Type',
    'support.pickUpRecord.table.pickUpAssociate': 'Pick-up Associate',
    'support.pickUpRecord.table.recorderName': 'Recorder Name',
    'support.pickUpRecord.table.recordTime': 'Record Time',
    'support.pickUpRecord.table.nominationType': 'Nomination Type',
    'support.pickUpRecord.table.employeeType': 'Employee Type',
    'support.pickUpRecord.table.nomineeEmployeeId': 'Nominee SAP Number',
    'support.pickUpRecord.table.submitDate': 'Submit Date',
    'support.pickUpRecord.table.nominee': 'Nominee',
    'support.pickUpRecord.table.nominatedCoreValue': 'Nominated Core Value',
    'support.pickUpRecord.table.nomineeIsSubGroup': "Nominee's SubGroup",
    'support.pickUpRecord.table.nomineeEmail': 'Nominee Email',
    'support.pickUpRecord.table.nomineeManagerStaffId': 'Nominee Manager SAP Number',
    'support.pickUpRecord.table.nomineeManagerName': 'Nominee Manager Name',
    'support.pickUpRecord.table.nomineeIsDivision': "Nominee's Division",
    'support.pickUpRecord.table.nomineeIsDept': "Nominee's Dept",
    'support.pickUpRecord.table.explanation': 'Nomination Story',
    'support.pickUpRecord.table.nominatorStaffId': 'Nominator SAP Number',
    'support.pickUpRecord.table.nominator': 'Nominator',
    'support.pickUpRecord.table.nominatorIsSubGroup': "Nominator's SubGroup",
    'support.pickUpRecord.table.nominatorEmail': 'Nominator Email',
    'support.pickUpRecord.table.nominatorIsDivision': "Nominator's Division",
    'support.pickUpRecord.table.nominatorIsDept': "Nominator's Dept",
    'support.pickUpRecord.table.certificate': 'Certificate',
    'support.pickUpRecord.table.equipment': 'Equipment',
    'support.pickUpRecord.table.action': 'Action',
    'support.pickUpRecord.edit.pickUpLog': 'Pick-up Log',
    'support.pickUpRecord.edit.associateStaffId': 'Pick-up Associate Staff ID',
    'support.pickUpRecord.edit.giftType': 'Gift Type',
    'support.pickUpRecord.edit.recordName': 'Record Name',
    'support.pickUpRecord.edit.recordTime': 'Record Time'


};
